import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 読み物の出典注記（本文直後・章末に添える小さな注記）。
 * 明朝・小さめの字・淡色で、上に細い区切り線を引く。各項目の頭に「―」を付ける。
 * 新書風の「章末注」として、資本論の引用元（巻・章）や他書籍・人物の出典を示す。
 * params: title（任意, 見出し文字。既定「出典」）、text（array, 出典リスト）
 */
export const ProseSource: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const title = (node.params.title as string) ?? '出典';
  const rawItems = node.params.text;
  const items: string[] = Array.isArray(rawItems) ? rawItems : rawItems ? [String(rawItems)] : [];

  return (
    <Box sx={{ borderTop: '1px solid #D8D3C8', mt: 2.5, pt: 1.5, mb: 2 }}>
      {title && (
        <Typography
          component="div"
          sx={{
            fontSize: 11,
            fontFamily: SERIF_FONT,
            color: '#999',
            letterSpacing: '0.08em',
            mb: 0.5,
          }}
        >
          {title}
        </Typography>
      )}
      <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
        {items.map((item, i) => (
          <Box
            component="li"
            key={i}
            sx={{
              fontSize: 12,
              fontFamily: SERIF_FONT,
              color: '#777',
              lineHeight: 1.9,
              display: 'flex',
              '&::before': {
                content: '"—"',
                color: '#AAA',
                mr: 0.8,
                flexShrink: 0,
              },
              '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
                margin: 0,
                fontFamily: 'inherit',
                fontSize: 'inherit',
                lineHeight: 'inherit',
                color: 'inherit',
                background: 'transparent',
              },
            }}
          >
            <Box component="span">{renderInline(item)}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ProseSource;
